module.exports = __webpack_public_path__ + "static/media/AthenianHoplite.8c18d603.jpg";